<script setup lang="ts">
const emits = defineEmits<{
  (event: 'clickLink'): void
}>()
</script>

<template>
  <router-link :to="{ name: 'RequestPasswordResetForm' }"  class="password-link" @click="emits('clickLink')">パスワードを忘れた方</router-link>
</template>

<style lang="scss" scoped>
.password-link{
  color: #4FC8A3;
  font-size: 1rem;
}
</style>
